import { useState } from "react"

import { useStep } from "@mobi/libraries/step"

import { useProposalContext } from "contexts/proposal"

import * as trackers from "../../trackings"

export function useSimulationOffer({ offer }) {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)

  function onDetailsModalClose() {
    setIsDetailsModalOpen(false)
  }

  function onDetailsModalOpen() {
    if (offer.amortization_system === "SAC") {
      trackers.seeSacDetails()
    } else if (offer.amortization_system === "PRICE") {
      trackers.seePriceDetails()
    }

    setIsDetailsModalOpen(true)
  }

  const { stepInfo, sendProposalData, errorHandler } = useProposalContext()

  const { nextStep } = stepInfo

  const { next } = useStep()

  const onSubmitOffer = async () => {
    try {
      const payload = {
        amortization_system: offer.amortization_system
      }
      await sendProposalData({ payload })

      trackers.choiceResult()
      next(nextStep)
    } catch (error) {
      trackers.alert(hashedCpf, error)
      errorHandler(error)
    }
  }

  return {
    isDetailsModalOpen,
    onDetailsModalOpen,
    onDetailsModalClose,
    onSubmitOffer
  }
}
